var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9261 17.7779H12.7409V14.8149C12.739 13.1793 11.4135 11.8539 9.77792 11.8519H6.22237C4.58677 11.8539 3.26133 13.1793 3.2594 14.8149V17.7779H2.07422V14.8149C2.0769 12.525 3.93252 10.6694 6.22237 10.6667H9.77792C12.0678 10.6694 13.9234 12.525 13.9261 14.8149V17.7779Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85205 5.33345C3.85205 3.04249 5.70924 1.1853 8.0002 1.1853C9.10036 1.1853 10.1555 1.62234 10.9334 2.40027C11.7113 3.1782 12.1483 4.23329 12.1483 5.33345C12.1483 7.62441 10.2912 9.4816 8.0002 9.4816C5.70924 9.4816 3.85205 7.62441 3.85205 5.33345ZM10.9632 5.33345C10.9632 3.69705 9.6366 2.37049 8.0002 2.37049C6.3638 2.37049 5.03724 3.69705 5.03724 5.33345C5.03724 6.96985 6.3638 8.29641 8.0002 8.29641C9.6366 8.29641 10.9632 6.96985 10.9632 5.33345Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileName);
export default __webpack_public_path__ + "static/media/profile-name.48914a8f.svg";
export { ForwardRef as ReactComponent };